import {Reference} from './reference';
import {Inline} from './inline';
import {OptionInfo} from './option-info';
import {FieldIf} from './field-if';
import {FieldValidation} from './field-validation';
import {FieldAction} from './field-action';
import {DateInfo} from './date-info';
import {InlineViewItem} from "./inline-view-item";
import {RefData} from "./ref-data";
import {TemplateFieldSelect} from './template-field';


export class FieldDisplayLabel extends InlineViewItem {
  type: string;
  title: string;
  name: string;
  key: string;
  path: string;
  sRef: RefData;
}

export interface MetaField {
  actions: Array<FieldAction>;
  actions_id: string;
  admin_title: string
  array_level: number;
  conditions_id: string;
  date_info: DateInfo;
  date_info_id: string;
  display: string;
  edit: string;
  field_ifs: Array<FieldIf>;
  field_name: string;
  field_title: string; // Mostly for operation fields
  field_type: string;
  field_uuid: string;
  ge: number;
  inline: Inline;
  inline_fields: Array<MetaField>;
  input_type: string;
  isSortable: boolean;
  is_array: boolean;
  is_required: string;
  keep?: boolean;
  key: string;
  le: number;
  max_length: number;
  meta_field_id: string;
  meta_field_id_value: string;
  min_length: number;
  model_type: string;
  name: string;
  option_info: OptionInfo;
  order: number;
  parent_field_ids: string[];
  parent_id: string;
  parent_ids: Array<string>;
  parent_name: string;
  parent_object_type: string;
  path: string;
  pattern: string; // Post-pydantic 2.x
  placeholder: string;
  reference: Reference;
  reference_id: string;
  regex: string; // Pre-pydantic 2.x, remove when all backends >= 10.0.234
  sub_fields: Array<MetaField>;
  sub_order: number;
  source_superobject_type_id?: string;
  superobject_type_ids: string[];
  template_field_select?: TemplateFieldSelect;
  template_group_id: string;
  title: string;
  validation: FieldValidation;
  value: any;
  value_option_id: string;

  $$fieldTitle: string;
  $$fieldColumnName: string;
  $$hide: boolean;
  $$inlineView: InlineViewItem;
}
